module.exports = new __parcel__URL__("closed-hihat_2.df9c6d68.mp3").toString();